module.exports = ".office-name{white-space:pre-line}\n"